omadapp.singletons.idDeliver = new(function() {
	var t = this
	var cont=0
	t.getId = function() {
		cont++
		return cont
	}


})